import React, { useRef } from 'react'
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia, Section, TextBox } from '../../components/imports';

const Content = () => {

  const heroRef = useRef(null);
  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>

          {/* FOR IDENTITY */}
          <div>
            <ImageMedia src={require("./assets/LP_StationeryVisualization.jpg")} />

          </div>

          {/* <Section className={"flex flex-col lg:flex-row w-full max-md:gap-6 gap-x-6 paddingX mt-4 lg:h-[80vh]"}> */}
          <div className='grid grid-cols-1 lg:grid-cols-2 w-full bg-black= pt-12'>
            <MotionContent imgRef={heroRef} height={"lg:h-[100vh]"} translateRange={["10%", "-5%"]}>
              <ImageMedia key={"img" + projectId} src={require("./assets/LP_BookHolder.jpg")} className="relative md:landscape:scale-[110%] full object-cover " />
            </MotionContent>
            <MotionContent imgRef={heroRef} height={"lg:h-[100vh]"} translateRange={["10%", "-5%"]}>
              <ImageMedia key={"img2" + projectId} src={require("./assets/LP_HardHat.jpg")} className="relative md:landscape:scale-[110%] full object-cover " />
            </MotionContent>
          </div>

          {/*             <MotionContent imgRef={heroRef} height={"fill"}>
            </MotionContent>
            <MotionContent height={"fill"}>
            </MotionContent> */}
          {/* </Section> */}

          <Section id={"office"} padded>
            <TextBox resp title={"L'espace"} descr={"L'implémentation de cette nouvelle identité est le drapeau porté par tous les partis prenants à l'active de Layepro Consulting et le logo logo en est le symbole. "} />
            <MotionContent imgRef={heroRef} height={""} className={"mt-16"}>
              <ImageMedia src={require("./assets/office.jpg")} className="object-cover full" />
            </MotionContent>
          </Section>

        </div>
      )}
    </ThisProject>
  )
}

export default Content